import React, { useContext, useCallback, useEffect, Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { GlobalMusicContext } from '../../context/GlobalMusicContext'
import { useColorMode } from '@chakra-ui/react'
import SearchBox from './SearchBox'
import { ReactComponent as DarkSVG } from '../../assets/ios-moon.svg'
import { ReactComponent as LightSVG } from '../../assets/ios-sunny.svg'
import logo from '../../assets/logo192.png'

const Navbar = ( props ) => {
  const { colorMode, toggleColorMode } = useColorMode()
  const [{ searchState }, dispatch] = useContext( GlobalMusicContext )
  // eslint-disable-next-line padded-blocks
  const setSearchState = useCallback( data => {
    dispatch( { type: "setSearchState", snippet: data } )
  },
    [dispatch]
  )

  useEffect( () => {
    const changeAppBar = () => {
      const path = props.history.location.pathname
      if ( path === "/search" ) {
        setSearchState( "searching" )
      } else {
        setSearchState( "home" )
      }
      // console.log( "history change detected in app bar" )
    }
    changeAppBar()
    // eslint-disable-next-line
    const unlisten = props.history.listen( location => {
      changeAppBar()
    } )
    // unlisten()
  }, [setSearchState, props.history] )

  const toggleSearch = () => {
    if ( searchState === "home" ) {
      return (
        <Fragment>
          <div className="navbar__wrapper">
            <nav className="navbar__nav">
              <Link to="/home" className="logo__link">
                <img src={logo} alt={logo} className="logo"
                />
              </Link>
              <button
                type="submit"
                className="nav__svg"
                onClick={() => setSearchState( "clicked" )}
              >
              </button>
              <button
                type="button"
                className="button nav__themeToggler"
                onClick={toggleColorMode}
              >
                {colorMode === 'light'
                  ? <DarkSVG />
                  : <LightSVG />
                }
              </button>
              <Link
                to="/about"
                className="nav temp__navlinks"
                style={{
                  margin: " 0 0.2rem 0 0.5rem"
                }}
              >
                ABOUT
              </Link>
              {/* <Link
                to="/playlists"
                className="nav temp__navlinks"
              >
                EXPLORE
              </Link> */}
            </nav>
          </div>
        </Fragment>
      )
    } else {
      return <SearchBox />
    }
  }

  return (
    <header id="navbar">
      {toggleSearch()}
    </header>
  )
}

export default withRouter( Navbar )